import uniqid from 'uniqid'

function transformations(html) {
  let _dom
  let _uuid
  let _style
  let _bodyClassName

  const _init = (html) => {
    _uuid = uniqid('__transformed-preview')
    _dom = _stringToDOM(html)
    _createStyle()
    _appendBodyClass()
  }

  _init(html)

  const o = {
    get style() {
      return { content: _style.innerHTML, id: _style.id }
    },
    /**
     * Returns stringified html
     */
    getHtml() {
      return '' + _dom.documentElement.outerHTML
    },
    injectCss(css) {
      _injectCss(css)
      return o
    },
    /**
     * Inject css in <head> to disable pointer events on specified selector
     * @param {String} selector scss selector to apply rule to
     */
    disablePointerEvents(selector) {
      const css = `
      ${selector} {
        pointer-events: none!important
      }`
      _injectCss(css)
      return o
    },
    /**
     * Replaces all anchors `href` attributes as per dictionary
     * @param {Object.<string,string|array<string>>} dictionary
     *  replace values with correspondent key
     */
    replaceHref(dictionary) {
      Object.entries(dictionary).forEach(([replace, search]) => {
        ;[].concat(search).forEach((term) => {
          ;[..._dom.querySelectorAll(`a[href="${term}"]`)].forEach((node) => {
            node.href = replace
          })
        })
      })
      return o
    },
    /**
     * add rel="noopener" to links with target="_blank"
     * @param {string} rel new rel attribute value
     */
    secureBlankTargets(rel = 'noopener') {
      _dom.querySelectorAll('a[target="_blank"]:not([rel])').forEach((node) => {
        node.rel = rel
      })
      return o
    },
    /**
     * Do whatever you want passing a function that directly mutates dom
     * @param {function} customTransformation
     */
    freeTransform(fn) {
      try {
        fn(_dom)
      } catch (e) {
        // console.error(e)
      }
      return o
    }
  }

  /**
   * Convert a template string into HTML DOM nodes
   * @private
   * @param  {String} html The template string
   * @return {Node}       The template HTML
   */
  function _stringToDOM(html) {
    const parser = new DOMParser()
    const dom = parser.parseFromString(html, 'text/html')
    return dom
  }

  function _createStyle() {
    _style = _dom.createElement('style')
    _style.id = `${_uuid}__style`
    _dom.head.appendChild(_style)
  }

  function _appendBodyClass() {
    _bodyClassName = `${_uuid}__body`
    _dom.body.classList.add(_bodyClassName)
  }

  const _withBodyClass = (strings, ...values) => {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (values[i] || '')
    })

    return `.${_bodyClassName} ${str}`
  }

  function _injectCss(css) {
    const cssWithBodyClass = _withBodyClass`${css}`
    _style.innerHTML += cssWithBodyClass + '\n'
  }

  return o
}

export default transformations
